import React from "react";
import Image from "next/image";

import sharedSnippetsExample from "assets/teams/shared-snippets-example.png";

import Snippets from "assets/iconsv2/snippets-16.svg";
import ArrowRight from "assets/icons/arrow-right.svg";

import TeamsHighlight from "./TeamsHighlight";

const TeamsSharedSnippets: React.FC = () => {
  return (
    <div>
      <TeamsHighlight dir="ltr" img={<Image alt="Shared Snippets" src={sharedSnippetsExample} layout="responsive" />}>
        <strong>
          <Snippets className="icon" />
          Shared Snippets
        </strong>

        <h4>Cut time and save hassle to communicate more efficiently</h4>
        <p>
          Write faster by using Shared Snippets to store and insert the text your teams use most. Create canned
          responses to help with support, easily give code reviews in a set format and embed consistency across
          documentation.
        </p>
        <p>Expand them automatically with a keyword, to write more while typing less. All in a snip.</p>

        <a href="https://manual.raycast.com/snippets" target="_blank" rel="noreferrer">
          Learn more about Snippets <ArrowRight className="icon" />
        </a>
      </TeamsHighlight>
    </div>
  );
};

export default TeamsSharedSnippets;
